import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M17.766 8.23a.785.785 0 0 0-1.115.006l-5.75 5.84-2.547-2.628a.786.786 0 0 0-1.115-.016.795.795 0 0 0-.016 1.12l3.107 3.208q.002.002.006.005.002.002.004.006c.05.05.111.08.17.113.03.016.055.044.086.057a.78.78 0 0 0 .594.001c.03-.013.054-.038.083-.054.06-.033.12-.062.171-.112l.005-.007.006-.004 6.317-6.415a.796.796 0 0 0-.006-1.12"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }